import { Input } from 'antd';
import _ from 'lodash';
import React, { forwardRef, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GET_API } from '../../api';
import * as SYSTEM from '../../constants/system.keys';
import storageService from '../../services/storage.service';
import './index.scss';
import { useSelector } from 'react-redux';

const LocationSearchLocationIQ = forwardRef(
  (
    {
      address,
      onAddressSelect,
      setIsBlock,
      onChange,
      namespace: propNamespace,
      setIsLoadingLatLng = () => { },
      debounceTime = 600,
    },
    ref
  ) => {
    const storeNamespace = useSelector((state) => state.namespace);
    const namespace = propNamespace || storeNamespace;
    const { t } = useTranslation();
    const [localAddress, setLocalAddress] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [temporaryDisableSearch, setTemporaryDisableSearch] = useState(true);
    const [isShowSelect, setIsShowSelect] = useState(true);

    const debouncedSearchAddress = useCallback(
      _.debounce(async (address) => {
        setLoading(true);
        try {
          const token = storageService.getInternalStorageByKey(
            SYSTEM.DECODED_ACCESS_TOKEN
          );
          const { data } = await GET_API(
            `https://resource-api.beex.vn:8050/locations?keyword=${address}`,
            token,
            {
              namespace,
            }
          );

          setSuggestions(data.records || []);
        } catch (error) {
          setSuggestions([]);
        } finally {
          setLoading(false);
        }
      }, debounceTime),
      [namespace]
    );

    useEffect(() => {
      setLocalAddress(address);
      if (address && !temporaryDisableSearch) debouncedSearchAddress(address);
    }, [
      address,
      debouncedSearchAddress,
      setLocalAddress,
      temporaryDisableSearch,
    ]);

    const handleChangeAddressInput = (e) => {
      setTemporaryDisableSearch(false);
      if (onChange && e) onChange(e.target.value);
    };

    const handleClickSuggestionItem = async (suggestion) => {
      console.log('🚀 ~ handleClickSuggestionItem ~ suggestion:', suggestion)
      setTemporaryDisableSearch(true);
      setIsLoadingLatLng(true);
      const token = storageService.getInternalStorageByKey(
        SYSTEM.DECODED_ACCESS_TOKEN
      );
      const { data } = await GET_API(
        `https://resource-api.beex.vn:8050/places?placeId=${suggestion.place_id}`,
        token,
        {
          namespace,
        }
      );

      onAddressSelect({
        note: suggestion.address,
        lat: data.record.lat,
        lng: data.record.lng,
      });
      setIsLoadingLatLng(false);
      setSuggestions([]);
    };

    return (
      <>
        <div className="custom-input-map">
          <Input
            onChange={handleChangeAddressInput}
            value={localAddress}
            ref={ref}
            placeholder={t('Search Places ...')}
            className="custom-input"
            onClick={() => setIsShowSelect(true)}
            onBlur={() => {
              setTimeout(() => {
                setIsShowSelect(false);
              }, 200);
            }}
          />
          {isShowSelect && (
            <div className="autocomplete-dropdown-container">
              {loading ? <div>{t('Loading...')}</div> : null}
              {suggestions.map((suggestion, index) => (
                <div
                  key={`${suggestion.place_id}-${index}`}
                  className="suggestion-item"
                  onMouseDown={() => handleClickSuggestionItem(suggestion)}
                >
                  {suggestion.address}
                </div>
              ))}
            </div>
          )}
        </div>
      </>
    );
  }
);

export default LocationSearchLocationIQ;
